@if (!isAppMobile) {
  <h1 class="dsd-b-30 dsd-color-font-secondary dsd-mb-xs">
    {{ 'coordonnees.titre' | translate }}
  </h1>
}
<h2 id="titreModification" tabindex="-1">{{ 'modifierAdresse.titre' | translate }}</h2>
<dsd-form [formGroup]="formGroup" (dsdFormSubmit)="naviguerVersPageValidation($event)">
  <p class="dsd-fw-bold dsd-b-40 dsd-mb-md">{{ 'formulaire.ajoutdechamps' | translate }}</p>
  <dsd-container>
    <app-modification-adresse [formGroup]="formGroup"> </app-modification-adresse>
  </dsd-container>
  <dsd-container>
    <app-questionnaire-dgag [formGroup]="formGroup"> </app-questionnaire-dgag>
  </dsd-container>
  <div class="zone-btn">
    <dsd-button variant="primary" full-width="xs" type="submit"
      >{{ 'bouton.valider' | translate }}
    </dsd-button>
    <dsd-button full-width="xs" id="btnAnnuler" (dsdButtonClick)="annulerModification()">{{
      'bouton.annuler' | translate
    }}</dsd-button>
  </div>
</dsd-form>
